import CommentScreen from "./comment-screen";

export default CommentScreen;